module.exports = __webpack_public_path__ + "static/media/instagram.522560b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/instagram.svg
// module id = 31
// module chunks = 0